// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Zendesk Web Widget–style launcher + messenger (custom, uses POST /support) */

.support-widget-root,
.support-page__form-body {
  /* N-Drip grey45 / Zendesk u-userLauncherColor — launcher + form accent */
  --support-theme-primary: #4d5674;
  --support-theme-primary-hover: #434b61;
  --support-theme-on-primary: #fff;
  --support-theme-primary-rgb: 77, 86, 116;
  --support-theme-focus-ring: rgba(var(--support-theme-primary-rgb), 0.25);
  --support-theme-focus-ring: rgba(var(--support-theme-primary-rgb), 0.25);
  --support-theme-active-surface: rgba(var(--support-theme-primary-rgb), 0.08);
  --support-theme-active-surface: rgba(var(--support-theme-primary-rgb), 0.08);
  /* Zendesk Web Widget messenger typography */
  --support-font-family:
    system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', Arial, sans-serif;
  --support-font-size: 14px;
  --support-font-size-sm: 13px;
  --support-font-size-launcher: 15px;
}

.support-widget-root {
  position: fixed;
  bottom: 4px;
  right: 0;
  z-index: 999998;
  margin: 10px 20px;
  font-family: var(--support-font-family);
  font-family: var(--support-font-family);
  font-size: var(--support-font-size);
  font-size: var(--support-font-size);
  -webkit-text-size-adjust: 100%;
  -moz-text-size-adjust: 100%;
       text-size-adjust: 100%;
  font-feature-settings: 'kern', 'kern', "kern";
  font-kerning: normal;
  line-height: normal;
  pointer-events: none;
  --support-launcher-bg: var(--support-theme-primary);
  --support-launcher-bg: var(--support-theme-primary);
  --support-launcher-bg-hover: var(--support-theme-primary-hover);
  --support-launcher-bg-hover: var(--support-theme-primary-hover);
  --support-launcher-color: var(--support-theme-on-primary);
  --support-launcher-color: var(--support-theme-on-primary);
  --support-launcher-font-family: var(--support-font-family);
  --support-launcher-font-family: var(--support-font-family);
  --support-launcher-font-size: var(--support-font-size-launcher);
  --support-launcher-font-size: var(--support-font-size-launcher);
  --support-launcher-line-height: 17.5px;
  --support-launcher-padding-y: 13px;
  --support-launcher-padding-x: 22px;
}

.support-widget-root * {
  box-sizing: border-box;
}

.support-widget-root--open .support-widget-panel--open {
  pointer-events: auto;
}

.support-widget-root--open {
  pointer-events: auto;
}

.support-widget-panel {
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 1;
  width: 342px;
  max-width: calc(100vw - 40px);
  max-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  font-family: var(--support-font-family);
  font-family: var(--support-font-family);
  font-size: var(--support-font-size);
  font-size: var(--support-font-size);
  line-height: normal;
  -webkit-text-size-adjust: 100%;
  -moz-text-size-adjust: 100%;
       text-size-adjust: 100%;
  font-feature-settings: 'kern', 'kern', "kern";
  font-kerning: normal;
  background: #fff;
  border-radius: 8px;
  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.15),
    0 0 1px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  opacity: 0;
  visibility: hidden;
  transform: translateY(16px) scale(0.96);
  transform-origin: bottom right;
  transition:
    opacity 250ms cubic-bezier(0.645, 0.045, 0.355, 1),
    transform 250ms cubic-bezier(0.645, 0.045, 0.355, 1),
    visibility 250ms cubic-bezier(0.645, 0.045, 0.355, 1);
  pointer-events: none;
}

.support-widget-panel--open {
  opacity: 1;
  visibility: visible;
  transform: translateY(0) scale(1);
  pointer-events: auto;
}

/* Zendesk widget-header-view (data-testid) */
.support-widget-panel__header {
  display: block;
  height: 44px;
  padding: 14px 8px;
  background: var(--support-theme-primary) !important;
  background: var(--support-theme-primary) !important;
  box-sizing: border-box;
}

/* Zendesk TitleRow / HeaderRow */
.support-widget-panel__header-row {
  display: grid;
  grid-template-columns: 16px 1fr 16px;
  align-content: stretch;
  align-items: center;
  height: 100%;
  min-height: 0;
  box-sizing: inherit;
  font-feature-settings: 'kern', 'kern', "kern";
  font-kerning: normal;
  font: inherit;
  font-family: var(--support-font-family);
  font-family: var(--support-font-family);
  -webkit-text-size-adjust: 100%;
  -moz-text-size-adjust: 100%;
       text-size-adjust: 100%;
  line-height: normal;
  font-size: var(--support-font-size);
  font-size: var(--support-font-size);
  font-weight: inherit;
  color: rgb(255, 255, 255) !important;
}

.support-widget-panel__header-spacer {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

/* Zendesk widget-title (data-testid) */
.support-widget-panel__title {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  font-weight: 800;
  font-style: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  -webkit-text-size-adjust: inherit;
  -moz-text-size-adjust: inherit;
       text-size-adjust: inherit;
  font-feature-settings: inherit;
  font-kerning: inherit;
  color: inherit !important;
  text-align: center;
  justify-self: center;
  width: 100%;
}

.support-widget-panel__close {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 16px;
  width: 16px;
  justify-self: end;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: inherit !important;
  cursor: pointer;
  transition: background-color 150ms ease;
}

.support-widget-panel__close:hover {
  background: rgba(255, 255, 255, 0.12);
}

.support-widget-panel__close svg {
  width: 16px;
  height: 16px;
}

.support-widget__form-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  font-family: var(--support-font-family);
  font-family: var(--support-font-family);
  font-size: var(--support-font-size);
  font-size: var(--support-font-size);
  line-height: normal;
}

.support-widget__intro {
  margin: 0 0 12px;
  font-family: inherit;
  font-size: inherit;
  line-height: 1.4;
  color: #68737d;
}

.support-widget__optional {
  font-weight: 400;
  color: #68737d;
}

.support-widget__field {
  margin-bottom: 12px;
}

.support-widget__label {
  display: block;
  margin-bottom: 4px;
  font-family: inherit;
  font-size: var(--support-font-size-sm);
  font-size: var(--support-font-size-sm);
  font-weight: 600;
  line-height: normal;
  height: 17.5px;
  color: #2f3941;
}

.support-widget__input,
.support-widget__textarea {
  width: 100%;
  padding: 8px 12px;
  font-family: inherit;
  font-size: inherit;
  line-height: 1.4;
  color: #2f3941;
  background: #f8f9f9;
  border: 1px solid #d8dcde;
  border-radius: 4px;
  transition:
    border-color 150ms ease,
    box-shadow 150ms ease;
}

.support-widget__input:disabled {
  opacity: 0.85;
  cursor: not-allowed;
}

.support-widget__textarea {
  min-height: 100px;
  resize: vertical;
}

.support-widget__input:focus,
.support-widget__textarea:focus {
  outline: none;
  border-color: var(--support-theme-primary);
  border-color: var(--support-theme-primary);
  box-shadow: 0 0 0 2px var(--support-theme-focus-ring);
  box-shadow: 0 0 0 2px var(--support-theme-focus-ring);
}

.support-widget__submit {
  width: 100%;
  margin-top: 4px;
  padding: 10px 16px;
  font-family: inherit;
  font-size: inherit;
  font-weight: 600;
  line-height: normal;
  color: var(--support-theme-on-primary);
  color: var(--support-theme-on-primary);
  background: var(--support-theme-primary);
  background: var(--support-theme-primary);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition:
    background-color 150ms ease,
    opacity 150ms ease;
}

.support-widget__submit:hover:not(:disabled) {
  background: var(--support-theme-primary-hover);
  background: var(--support-theme-primary-hover);
}

.support-widget__submit:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.support-widget__dropzone {
  position: relative;
  display: block;
  width: 100%;
  padding: 2px;
  border: 2px dashed transparent;
  border-radius: 6px;
  cursor: pointer;
  transition:
    border-color 200ms ease,
    background-color 200ms ease,
    box-shadow 200ms ease;
}

.support-widget__dropzone.focus-visible {
  outline: 2px solid var(--support-theme-primary);
  outline: 2px solid var(--support-theme-primary);
  outline-offset: 2px;
}

.support-widget__dropzone--active {
  border-color: var(--support-theme-primary);
  border-color: var(--support-theme-primary);
  background: var(--support-theme-active-surface);
  background: var(--support-theme-active-surface);
  box-shadow: inset 0 0 0 1px rgba(var(--support-theme-primary-rgb), 0.15);
  box-shadow: inset 0 0 0 1px rgba(var(--support-theme-primary-rgb), 0.15);
}

.support-widget__dropzone--disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.support-widget__file-input {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  opacity: 0;
  cursor: pointer;
}

.support-widget__dropzone--disabled .support-widget__file-input {
  pointer-events: none;
  cursor: not-allowed;
}

.support-widget__attachment-btn {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 10px 12px;
  border: 1px dashed #87929d;
  border-radius: 4px;
  background: #f8f9f9;
  color: #2f3941;
  font-family: inherit;
  font-size: inherit;
  line-height: 1.3;
  text-align: left;
  pointer-events: none;
  transition:
    border-color 150ms ease,
    background-color 150ms ease;
}

.support-widget__dropzone--active .support-widget__attachment-btn {
  border-color: var(--support-theme-primary);
  border-color: var(--support-theme-primary);
  background: #fff;
}

.support-widget__dropzone:hover:not(.support-widget__dropzone--disabled):not(
    .support-widget__dropzone--active
  )
  .support-widget__attachment-btn {
  border-color: var(--support-theme-primary);
  border-color: var(--support-theme-primary);
  background: #f3f5f5;
}

.support-widget__attachment-list {
  margin: 8px 0 0;
  padding: 0;
  list-style: none;
}

.support-widget__attachment-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 6px;
  padding: 6px 8px;
  border-radius: 4px;
  background: #f3f5f5;
  font-family: inherit;
  font-size: var(--support-font-size-sm);
  font-size: var(--support-font-size-sm);
}

.support-widget__attachment-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.support-widget__attachment-remove {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #68737d;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}

.support-widget__attachment-remove:hover:not(:disabled) {
  background: #e9ebed;
  color: #2f3941;
}

.support-widget__alert {
  margin-bottom: 12px;
  padding: 10px 12px;
  font-family: inherit;
  font-size: var(--support-font-size-sm);
  font-size: var(--support-font-size-sm);
  line-height: 1.4;
  border-radius: 4px;
}

.support-widget__alert--success {
  color: #186146;
  background: #edf8f4;
  border: 1px solid #c6e9d9;
}

.support-widget__alert--error {
  color: #8c232c;
  background: #fff0f1;
  border: 1px solid #f5b5ba;
}

.support-widget__alert--warning {
  color: #703b15;
  background: #fff7ed;
  border: 1px solid #ffd0a6;
}

/* Zendesk launcher button (iframe #launcher / data-testid="launcher") */
.support-widget-launcher {
  -webkit-text-size-adjust: 100%;
  -moz-text-size-adjust: 100%;
       text-size-adjust: 100%;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  display: flex !important;
  align-items: center;
  justify-content: flex-start;
  gap: 0;
  box-sizing: border-box;
  width: 135.7px;
  height: 46px;
  min-height: 46px;
  margin: 0;
  padding: var(--support-launcher-padding-y) var(--support-launcher-padding-x);
  padding: var(--support-launcher-padding-y) var(--support-launcher-padding-x);
  border: none !important;
  border-radius: 999rem;
  background-color: var(--support-launcher-bg) !important;
  background-color: var(--support-launcher-bg) !important;
  color: var(--support-launcher-color) !important;
  color: var(--support-launcher-color) !important;
  fill: var(--support-launcher-color) !important;
  fill: var(--support-launcher-color) !important;
  font-family: var(--support-launcher-font-family);
  font-family: var(--support-launcher-font-family);
  font-size: var(--support-launcher-font-size);
  font-size: var(--support-launcher-font-size);
  font-weight: 700 !important;
  font-style: normal;
  letter-spacing: 0.6px;
  line-height: 1;
  text-align: left !important;
  text-transform: none;
  white-space: nowrap !important;
  cursor: pointer !important;
  overflow: visible;
  opacity: 1;
  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.15),
    0 0 1px rgba(0, 0, 0, 0.12);
  transition:
    opacity 250ms cubic-bezier(0.645, 0.045, 0.355, 1),
    transform 250ms cubic-bezier(0.645, 0.045, 0.355, 1),
    background-color 150ms ease;
  position: relative;
  z-index: 2;
  pointer-events: auto;
}

.support-widget-launcher:hover {
  background-color: var(--support-launcher-bg-hover) !important;
  background-color: var(--support-launcher-bg-hover) !important;
}

.support-widget-launcher.focus-visible {
  outline: 2px solid #fff;
  outline-offset: 2px;
}

.support-widget-launcher__icon-wrap {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-right: 8px;
  color: inherit;
}

.support-widget-launcher__icon {
  display: block;
  width: 20px;
  height: 20px;
  fill: currentColor;
}

.support-widget-root .support-widget-launcher .support-widget-launcher__label {
  font-family: var(--support-launcher-font-family) !important;
  font-family: var(--support-launcher-font-family) !important;
  font-size: var(--support-launcher-font-size) !important;
  font-size: var(--support-launcher-font-size) !important;
  font-weight: 800 !important;
  font-style: normal !important;
  font-synthesis: weight;
  -webkit-font-smoothing: antialiased;
}

.support-widget-launcher__label {
  display: block;
  flex-shrink: 0;
  position: relative;
  color: inherit;
  fill: inherit;
  letter-spacing: inherit;
  line-height: var(--support-launcher-line-height);
  line-height: var(--support-launcher-line-height);
  transition: opacity 200ms ease;
}

@media (max-width: 480px) {
  .support-widget-panel {
    width: calc(100vw - 40px);
  }
}
`, "",{"version":3,"sources":["webpack://./app/components/support/SupportWidget.css"],"names":[],"mappings":"AAAA,+EAA+E;;AAE/E;;EAEE,yEAAyE;EACzE,gCAAgC;EAChC,sCAAsC;EACtC,gCAAgC;EAChC,wCAAwC;EACxC,wEAAwE;EACxE,wEAAwE;EACxE,4EAA4E;EAC5E,4EAA4E;EAC5E,4CAA4C;EAC5C;;uEAEqE;EACrE,yBAAyB;EACzB,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,uCAAuC;EACvC,uCAAuC;EACvC,mCAAmC;EACnC,mCAAmC;EACnC,8BAA8B;EAC9B,2BAA2B;OACtB,sBAAsB;EAC3B,6CAA6C;EAC7C,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,mDAAmD;EACnD,mDAAmD;EACnD,+DAA+D;EAC/D,+DAA+D;EAC/D,yDAAyD;EACzD,yDAAyD;EACzD,0DAA0D;EAC1D,0DAA0D;EAC1D,+DAA+D;EAC/D,+DAA+D;EAC/D,sCAAsC;EACtC,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,YAAY;EACZ,6BAA6B;EAC7B,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,uCAAuC;EACvC,mCAAmC;EACnC,mCAAmC;EACnC,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;OACtB,sBAAsB;EAC3B,6CAA6C;EAC7C,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB;;+BAE6B;EAC7B,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,uCAAuC;EACvC,8BAA8B;EAC9B;;;yDAGuD;EACvD,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA,6CAA6C;AAC7C;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,mDAAmD;EACnD,mDAAmD;EACnD,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,oCAAoC;EACpC,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,6CAA6C;EAC7C,oBAAoB;EACpB,aAAa;EACb,uCAAuC;EACvC,uCAAuC;EACvC,8BAA8B;EAC9B,2BAA2B;OACtB,sBAAsB;EAC3B,mBAAmB;EACnB,mCAAmC;EACnC,mCAAmC;EACnC,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,iCAAiC;EACjC,8BAA8B;OACzB,yBAAyB;EAC9B,8BAA8B;EAC9B,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,uCAAuC;EACvC,uCAAuC;EACvC,mCAAmC;EACnC,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,sCAAsC;EACtC,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB;;yBAEuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,0CAA0C;EAC1C,0CAA0C;EAC1C,qDAAqD;EACrD,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,sCAAsC;EACtC,wCAAwC;EACxC,wCAAwC;EACxC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf;;sBAEoB;AACtB;;AAEA;EACE,8CAA8C;EAC9C,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf;;;yBAGuB;AACzB;;AAEA;EACE,+CAA+C;EAC/C,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;EAC1C,+CAA+C;EAC/C,+CAA+C;EAC/C,wEAAwE;EACxE,wEAAwE;AAC1E;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB;;+BAE6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;;;;EAIE,0CAA0C;EAC1C,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,sCAAsC;EACtC,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,wEAAwE;AACxE;EACE,8BAA8B;EAC9B,2BAA2B;OACtB,sBAAsB;EAC3B,qBAAqB;OAChB,gBAAgB;EACrB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,2BAA2B;EAC3B,MAAM;EACN,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,4EAA4E;EAC5E,4EAA4E;EAC5E,uBAAuB;EACvB,qBAAqB;EACrB,uDAAuD;EACvD,uDAAuD;EACvD,+CAA+C;EAC/C,+CAA+C;EAC/C,8CAA8C;EAC9C,8CAA8C;EAC9C,gDAAgD;EAChD,gDAAgD;EAChD,4CAA4C;EAC5C,4CAA4C;EAC5C,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,oBAAoB;EACpB,8BAA8B;EAC9B,0BAA0B;EAC1B,iBAAiB;EACjB,UAAU;EACV;;+BAE6B;EAC7B;;;+BAG6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,6DAA6D;EAC7D,6DAA6D;AAC/D;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,2DAA2D;EAC3D,2DAA2D;EAC3D,uDAAuD;EACvD,uDAAuD;EACvD,2BAA2B;EAC3B,6BAA6B;EAC7B,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,gDAAgD;EAChD,gDAAgD;EAChD,8BAA8B;AAChC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* Zendesk Web Widget–style launcher + messenger (custom, uses POST /support) */\n\n.support-widget-root,\n.support-page__form-body {\n  /* N-Drip grey45 / Zendesk u-userLauncherColor — launcher + form accent */\n  --support-theme-primary: #4d5674;\n  --support-theme-primary-hover: #434b61;\n  --support-theme-on-primary: #fff;\n  --support-theme-primary-rgb: 77, 86, 116;\n  --support-theme-focus-ring: rgba(var(--support-theme-primary-rgb), 0.25);\n  --support-theme-focus-ring: rgba(var(--support-theme-primary-rgb), 0.25);\n  --support-theme-active-surface: rgba(var(--support-theme-primary-rgb), 0.08);\n  --support-theme-active-surface: rgba(var(--support-theme-primary-rgb), 0.08);\n  /* Zendesk Web Widget messenger typography */\n  --support-font-family:\n    system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,\n    Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', Arial, sans-serif;\n  --support-font-size: 14px;\n  --support-font-size-sm: 13px;\n  --support-font-size-launcher: 15px;\n}\n\n.support-widget-root {\n  position: fixed;\n  bottom: 4px;\n  right: 0;\n  z-index: 999998;\n  margin: 10px 20px;\n  font-family: var(--support-font-family);\n  font-family: var(--support-font-family);\n  font-size: var(--support-font-size);\n  font-size: var(--support-font-size);\n  -webkit-text-size-adjust: 100%;\n  -moz-text-size-adjust: 100%;\n       text-size-adjust: 100%;\n  font-feature-settings: 'kern', 'kern', \"kern\";\n  font-kerning: normal;\n  line-height: normal;\n  pointer-events: none;\n  --support-launcher-bg: var(--support-theme-primary);\n  --support-launcher-bg: var(--support-theme-primary);\n  --support-launcher-bg-hover: var(--support-theme-primary-hover);\n  --support-launcher-bg-hover: var(--support-theme-primary-hover);\n  --support-launcher-color: var(--support-theme-on-primary);\n  --support-launcher-color: var(--support-theme-on-primary);\n  --support-launcher-font-family: var(--support-font-family);\n  --support-launcher-font-family: var(--support-font-family);\n  --support-launcher-font-size: var(--support-font-size-launcher);\n  --support-launcher-font-size: var(--support-font-size-launcher);\n  --support-launcher-line-height: 17.5px;\n  --support-launcher-padding-y: 13px;\n  --support-launcher-padding-x: 22px;\n}\n\n.support-widget-root * {\n  box-sizing: border-box;\n}\n\n.support-widget-root--open .support-widget-panel--open {\n  pointer-events: auto;\n}\n\n.support-widget-root--open {\n  pointer-events: auto;\n}\n\n.support-widget-panel {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n  width: 342px;\n  max-width: calc(100vw - 40px);\n  max-height: calc(100vh - 100px);\n  display: flex;\n  flex-direction: column;\n  font-family: var(--support-font-family);\n  font-family: var(--support-font-family);\n  font-size: var(--support-font-size);\n  font-size: var(--support-font-size);\n  line-height: normal;\n  -webkit-text-size-adjust: 100%;\n  -moz-text-size-adjust: 100%;\n       text-size-adjust: 100%;\n  font-feature-settings: 'kern', 'kern', \"kern\";\n  font-kerning: normal;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow:\n    0 8px 24px rgba(0, 0, 0, 0.15),\n    0 0 1px rgba(0, 0, 0, 0.12);\n  overflow: hidden;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(16px) scale(0.96);\n  transform-origin: bottom right;\n  transition:\n    opacity 250ms cubic-bezier(0.645, 0.045, 0.355, 1),\n    transform 250ms cubic-bezier(0.645, 0.045, 0.355, 1),\n    visibility 250ms cubic-bezier(0.645, 0.045, 0.355, 1);\n  pointer-events: none;\n}\n\n.support-widget-panel--open {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0) scale(1);\n  pointer-events: auto;\n}\n\n/* Zendesk widget-header-view (data-testid) */\n.support-widget-panel__header {\n  display: block;\n  height: 44px;\n  padding: 14px 8px;\n  background: var(--support-theme-primary) !important;\n  background: var(--support-theme-primary) !important;\n  box-sizing: border-box;\n}\n\n/* Zendesk TitleRow / HeaderRow */\n.support-widget-panel__header-row {\n  display: grid;\n  grid-template-columns: 16px 1fr 16px;\n  align-content: stretch;\n  align-items: center;\n  height: 100%;\n  min-height: 0;\n  box-sizing: inherit;\n  font-feature-settings: 'kern', 'kern', \"kern\";\n  font-kerning: normal;\n  font: inherit;\n  font-family: var(--support-font-family);\n  font-family: var(--support-font-family);\n  -webkit-text-size-adjust: 100%;\n  -moz-text-size-adjust: 100%;\n       text-size-adjust: 100%;\n  line-height: normal;\n  font-size: var(--support-font-size);\n  font-size: var(--support-font-size);\n  font-weight: inherit;\n  color: rgb(255, 255, 255) !important;\n}\n\n.support-widget-panel__header-spacer {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n/* Zendesk widget-title (data-testid) */\n.support-widget-panel__title {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: 800;\n  font-style: inherit;\n  line-height: inherit;\n  letter-spacing: inherit;\n  -webkit-text-size-adjust: inherit;\n  -moz-text-size-adjust: inherit;\n       text-size-adjust: inherit;\n  font-feature-settings: inherit;\n  font-kerning: inherit;\n  color: inherit !important;\n  text-align: center;\n  justify-self: center;\n  width: 100%;\n}\n\n.support-widget-panel__close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 16px;\n  width: 16px;\n  justify-self: end;\n  padding: 0;\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  color: inherit !important;\n  cursor: pointer;\n  transition: background-color 150ms ease;\n}\n\n.support-widget-panel__close:hover {\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.support-widget-panel__close svg {\n  width: 16px;\n  height: 16px;\n}\n\n.support-widget__form-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n  font-family: var(--support-font-family);\n  font-family: var(--support-font-family);\n  font-size: var(--support-font-size);\n  font-size: var(--support-font-size);\n  line-height: normal;\n}\n\n.support-widget__intro {\n  margin: 0 0 12px;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: 1.4;\n  color: #68737d;\n}\n\n.support-widget__optional {\n  font-weight: 400;\n  color: #68737d;\n}\n\n.support-widget__field {\n  margin-bottom: 12px;\n}\n\n.support-widget__label {\n  display: block;\n  margin-bottom: 4px;\n  font-family: inherit;\n  font-size: var(--support-font-size-sm);\n  font-size: var(--support-font-size-sm);\n  font-weight: 600;\n  line-height: normal;\n  height: 17.5px;\n  color: #2f3941;\n}\n\n.support-widget__input,\n.support-widget__textarea {\n  width: 100%;\n  padding: 8px 12px;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: 1.4;\n  color: #2f3941;\n  background: #f8f9f9;\n  border: 1px solid #d8dcde;\n  border-radius: 4px;\n  transition:\n    border-color 150ms ease,\n    box-shadow 150ms ease;\n}\n\n.support-widget__input:disabled {\n  opacity: 0.85;\n  cursor: not-allowed;\n}\n\n.support-widget__textarea {\n  min-height: 100px;\n  resize: vertical;\n}\n\n.support-widget__input:focus,\n.support-widget__textarea:focus {\n  outline: none;\n  border-color: var(--support-theme-primary);\n  border-color: var(--support-theme-primary);\n  box-shadow: 0 0 0 2px var(--support-theme-focus-ring);\n  box-shadow: 0 0 0 2px var(--support-theme-focus-ring);\n}\n\n.support-widget__submit {\n  width: 100%;\n  margin-top: 4px;\n  padding: 10px 16px;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: 600;\n  line-height: normal;\n  color: var(--support-theme-on-primary);\n  color: var(--support-theme-on-primary);\n  background: var(--support-theme-primary);\n  background: var(--support-theme-primary);\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition:\n    background-color 150ms ease,\n    opacity 150ms ease;\n}\n\n.support-widget__submit:hover:not(:disabled) {\n  background: var(--support-theme-primary-hover);\n  background: var(--support-theme-primary-hover);\n}\n\n.support-widget__submit:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.support-widget__dropzone {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 2px;\n  border: 2px dashed transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  transition:\n    border-color 200ms ease,\n    background-color 200ms ease,\n    box-shadow 200ms ease;\n}\n\n.support-widget__dropzone.focus-visible {\n  outline: 2px solid var(--support-theme-primary);\n  outline: 2px solid var(--support-theme-primary);\n  outline-offset: 2px;\n}\n\n.support-widget__dropzone--active {\n  border-color: var(--support-theme-primary);\n  border-color: var(--support-theme-primary);\n  background: var(--support-theme-active-surface);\n  background: var(--support-theme-active-surface);\n  box-shadow: inset 0 0 0 1px rgba(var(--support-theme-primary-rgb), 0.15);\n  box-shadow: inset 0 0 0 1px rgba(var(--support-theme-primary-rgb), 0.15);\n}\n\n.support-widget__dropzone--disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.support-widget__file-input {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.support-widget__dropzone--disabled .support-widget__file-input {\n  pointer-events: none;\n  cursor: not-allowed;\n}\n\n.support-widget__attachment-btn {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px dashed #87929d;\n  border-radius: 4px;\n  background: #f8f9f9;\n  color: #2f3941;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: 1.3;\n  text-align: left;\n  pointer-events: none;\n  transition:\n    border-color 150ms ease,\n    background-color 150ms ease;\n}\n\n.support-widget__dropzone--active .support-widget__attachment-btn {\n  border-color: var(--support-theme-primary);\n  border-color: var(--support-theme-primary);\n  background: #fff;\n}\n\n.support-widget__dropzone:hover:not(.support-widget__dropzone--disabled):not(\n    .support-widget__dropzone--active\n  )\n  .support-widget__attachment-btn {\n  border-color: var(--support-theme-primary);\n  border-color: var(--support-theme-primary);\n  background: #f3f5f5;\n}\n\n.support-widget__attachment-list {\n  margin: 8px 0 0;\n  padding: 0;\n  list-style: none;\n}\n\n.support-widget__attachment-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 6px;\n  padding: 6px 8px;\n  border-radius: 4px;\n  background: #f3f5f5;\n  font-family: inherit;\n  font-size: var(--support-font-size-sm);\n  font-size: var(--support-font-size-sm);\n}\n\n.support-widget__attachment-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.support-widget__attachment-remove {\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  color: #68737d;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.support-widget__attachment-remove:hover:not(:disabled) {\n  background: #e9ebed;\n  color: #2f3941;\n}\n\n.support-widget__alert {\n  margin-bottom: 12px;\n  padding: 10px 12px;\n  font-family: inherit;\n  font-size: var(--support-font-size-sm);\n  font-size: var(--support-font-size-sm);\n  line-height: 1.4;\n  border-radius: 4px;\n}\n\n.support-widget__alert--success {\n  color: #186146;\n  background: #edf8f4;\n  border: 1px solid #c6e9d9;\n}\n\n.support-widget__alert--error {\n  color: #8c232c;\n  background: #fff0f1;\n  border: 1px solid #f5b5ba;\n}\n\n.support-widget__alert--warning {\n  color: #703b15;\n  background: #fff7ed;\n  border: 1px solid #ffd0a6;\n}\n\n/* Zendesk launcher button (iframe #launcher / data-testid=\"launcher\") */\n.support-widget-launcher {\n  -webkit-text-size-adjust: 100%;\n  -moz-text-size-adjust: 100%;\n       text-size-adjust: 100%;\n  -moz-appearance: none;\n       appearance: none;\n  -webkit-appearance: none;\n  display: flex !important;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0;\n  box-sizing: border-box;\n  width: 135.7px;\n  height: 46px;\n  min-height: 46px;\n  margin: 0;\n  padding: var(--support-launcher-padding-y) var(--support-launcher-padding-x);\n  padding: var(--support-launcher-padding-y) var(--support-launcher-padding-x);\n  border: none !important;\n  border-radius: 999rem;\n  background-color: var(--support-launcher-bg) !important;\n  background-color: var(--support-launcher-bg) !important;\n  color: var(--support-launcher-color) !important;\n  color: var(--support-launcher-color) !important;\n  fill: var(--support-launcher-color) !important;\n  fill: var(--support-launcher-color) !important;\n  font-family: var(--support-launcher-font-family);\n  font-family: var(--support-launcher-font-family);\n  font-size: var(--support-launcher-font-size);\n  font-size: var(--support-launcher-font-size);\n  font-weight: 700 !important;\n  font-style: normal;\n  letter-spacing: 0.6px;\n  line-height: 1;\n  text-align: left !important;\n  text-transform: none;\n  white-space: nowrap !important;\n  cursor: pointer !important;\n  overflow: visible;\n  opacity: 1;\n  box-shadow:\n    0 4px 12px rgba(0, 0, 0, 0.15),\n    0 0 1px rgba(0, 0, 0, 0.12);\n  transition:\n    opacity 250ms cubic-bezier(0.645, 0.045, 0.355, 1),\n    transform 250ms cubic-bezier(0.645, 0.045, 0.355, 1),\n    background-color 150ms ease;\n  position: relative;\n  z-index: 2;\n  pointer-events: auto;\n}\n\n.support-widget-launcher:hover {\n  background-color: var(--support-launcher-bg-hover) !important;\n  background-color: var(--support-launcher-bg-hover) !important;\n}\n\n.support-widget-launcher.focus-visible {\n  outline: 2px solid #fff;\n  outline-offset: 2px;\n}\n\n.support-widget-launcher__icon-wrap {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  margin-right: 8px;\n  color: inherit;\n}\n\n.support-widget-launcher__icon {\n  display: block;\n  width: 20px;\n  height: 20px;\n  fill: currentColor;\n}\n\n.support-widget-root .support-widget-launcher .support-widget-launcher__label {\n  font-family: var(--support-launcher-font-family) !important;\n  font-family: var(--support-launcher-font-family) !important;\n  font-size: var(--support-launcher-font-size) !important;\n  font-size: var(--support-launcher-font-size) !important;\n  font-weight: 800 !important;\n  font-style: normal !important;\n  font-synthesis: weight;\n  -webkit-font-smoothing: antialiased;\n}\n\n.support-widget-launcher__label {\n  display: block;\n  flex-shrink: 0;\n  position: relative;\n  color: inherit;\n  fill: inherit;\n  letter-spacing: inherit;\n  line-height: var(--support-launcher-line-height);\n  line-height: var(--support-launcher-line-height);\n  transition: opacity 200ms ease;\n}\n\n@media (max-width: 480px) {\n  .support-widget-panel {\n    width: calc(100vw - 40px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
